import React, { forwardRef, Ref, TextareaHTMLAttributes } from "react";
import cn from "classnames";
import { FormElementProps } from ".";
import Styles from "./forms.module.scss";

interface TextareaProps extends FormElementProps, Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, "size"> {
  formatted?: boolean;
  className?: string;
  value?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement | HTMLDivElement, TextareaProps>((props, ref) => {
  const {
    size = "md",
    stretch,
    customClass,
    className,
    onChange,
    formatted = false,
    value = "",
    ...rest
  } = props;

  const classes = cn(
    customClass || Styles.textarea,
    className,
    size,
    {
      "w-full": stretch,
    }
  );

  if (!formatted) {
    const textareaProps = rest as TextareaHTMLAttributes<HTMLTextAreaElement>;
    return (
      <textarea
        ref={ref as Ref<HTMLTextAreaElement>}
        className={classes}
        onChange={onChange}
        value={value}
        {...textareaProps}
      />
    );
  }

  const divProps = rest as TextareaHTMLAttributes<HTMLTextAreaElement>;
  const onDivScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const handler = divProps.onScroll as unknown as React.UIEventHandler<HTMLTextAreaElement> | undefined;
    if (typeof handler === 'function') {
      handler(e as unknown as React.UIEvent<HTMLTextAreaElement>);
    }
  };

  return (
    <div
      ref={ref as Ref<HTMLDivElement>}
      id={divProps.id}
      className={classes}
      role="textbox"
      aria-readonly
      aria-label={divProps['aria-label']}
      tabIndex={0}
      onScroll={onDivScroll}
      dangerouslySetInnerHTML={{ __html: value }}
    />
  );
});

Textarea.displayName = "Textarea";

export default Textarea;
